// Home da "Página completa" no hotsite (Views/Home/IndexHotSiteV2): os banners, os trilhos, o "Carregar mais", as fotos, o vídeo,
// a vaga no painel de baixo (celular) e o topo sobre a 1ª seção. O rodapé ("Nossas informações") já vem no HTML desta página.
import { textos, url } from './v2/config';
import { iniciarBanners, iniciarTrilhos } from './v2/hotsite-carrossel';
import { iniciarFotos, iniciarVideo } from './v2/hotsite-midia';
import { iniciarVitrine } from './v2/hotsite-vitrine';
import { abrirNoSheet, fecharCompartilhar, fecharSheet, iniciarVaga } from './v2/vaga';

const _ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;

// No celular a vaga da vitrine abre no painel de baixo, como na página da empresa (fanpage-v2.js); no computador o link leva à
// página da vaga. O painel (_PaineisV2) só vem com a seção de vagas.
function _iniciarVagaNoPainel(t) {
    if (!document.getElementById('sheetVaga')) {
        return;
    }
    // A vitrine agrupada repete a vaga que está em mais de um grupo: sem os repetidos, o Anterior/Próxima não anda em laço.
    const ids = () => [...new Set([...document.querySelectorAll('#section-vagas .cartao-vaga[data-id]')].map(c => +c.dataset.id))];
    let textosVaga = {};
    try {
        textosVaga = JSON.parse(document.getElementById('busca-v2-textos')?.textContent || '{}');
    } catch {
        textosVaga = {};
    }
    const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    iniciarVaga({
        textos: textosVaga,
        itens: '#section-vagas .cartao-vaga',
        padrao: { empresa: t.empresa || '', logo: t.logo ? `<img src="${esc(t.logo)}" alt="" width="44" height="44">` : '' },
        lista: ids,
        total: () => ids().length,
        temMais: () => false
    });
    document.addEventListener('click', e => {
        const link = e.target.closest('#section-vagas a[data-vaga]');
        if (!link || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || !_ehCelular()) {
            return;
        }
        e.preventDefault();
        abrirNoSheet(+link.dataset.vaga);
    });
    document.addEventListener('keydown', e => {
        if (e.key !== 'Escape' || document.querySelector('dialog[open]') || fecharCompartilhar()) {
            return;
        }
        const aberto = [...document.querySelectorAll('.sheet.is-open:not(#sheetMenu)')].pop();
        if (aberto) {
            fecharSheet(aberto);
        }
    });

    // Link com ?vaga= no celular (o Voltar do login no meio da candidatura, o recarregar com o painel aberto): a vaga abre por cima.
    const id = +new URLSearchParams(window.location.search).get('vaga');
    if (!id || !_ehCelular()) {
        return;
    }
    const naVitrine = ids().includes(id);
    if (naVitrine) {
        document.querySelector(`#section-vagas .cartao-vaga[data-id="${id}"]`)?.scrollIntoView({ block: 'center' });
    }
    // O vaga.js já leu o "confirmar" ao iniciar: os dois saem do endereço que fica embaixo do painel.
    const u = new URL(window.location.href);
    u.searchParams.delete('vaga');
    u.searchParams.delete('confirmar');
    history.replaceState(history.state, '', u.pathname + u.search);
    // Fora da 1ª página da vitrine (veio pelo "Carregar mais"), o cabeçalho espera a vaga, que traz a empresa dela.
    abrirNoSheet(id, naVitrine ? {} : { info: { id, titulo: '', empresa: '', logo: '', href: `/v${id}`, pills: '' } });
}

// Topo transparente (só sobre o banner ou o bloco de HTML de ponta a ponta que abre a página) e flutuante: a 1ª seção sobe para baixo da barra pela
// altura medida aqui (--hs-topo-sobre, sem a faixa de aviso, que continua empurrando), e o transparente ganha fundo ao rolar.
function _iniciarTopo() {
    const topo = document.getElementById('topo-v2');
    if (!topo || !topo.matches('.hs-topo-transparente, .hs-topo-flutuante')) {
        return;
    }
    const medir = () => {
        const aviso = topo.querySelector('.hs-aviso');
        document.documentElement.style.setProperty('--hs-topo-sobre', `${topo.offsetHeight - (aviso ? aviso.offsetHeight : 0)}px`);
    };
    medir();
    if ('ResizeObserver' in window) {
        new ResizeObserver(medir).observe(topo);
    }
    if (topo.classList.contains('hs-topo-transparente')) {
        const marcar = () => topo.classList.toggle('hs-topo-rolado', window.scrollY > 8);
        marcar();
        window.addEventListener('scroll', marcar, { passive: true });
    }
}

// A pílula "Buscar vagas" do topo de quem entrou abre a busca em tela cheia nas telas que a trazem (#tpl-sov); esta home não traz
// (aba "inicio"): a pílula leva à busca do hotsite.
function _iniciarPilulaDoTopo() {
    document.addEventListener('click', e => {
        const pilula = e.target.closest('.hnav--busca .mpill');
        if (!pilula || e.defaultPrevented || document.getElementById('tpl-sov') || document.getElementById('sov')) {
            return;
        }
        e.preventDefault();
        window.location.assign(url('/vagas'));
    });
}

const t = textos(document.getElementById('hotsite-employer-page'));
_iniciarTopo();
_iniciarPilulaDoTopo();
iniciarBanners(t);
iniciarTrilhos();
iniciarVitrine(t);
_iniciarVagaNoPainel(t);
iniciarFotos(t);
iniciarVideo();
